<p-card>
    <div class="row flex">
      <div class="col-12">
        <h1 class="mb-3">Cartera general de la plataforma</h1>
        <p class="mb-3 text-color-secondary">
          En esta sección tendrás acceso a la información general de la cartera de la plataforma, incluyendo el valor total de la cartera, el valor sin accesorios, y el número de arrendamientos activos.
        </p>
      </div>
      <p-toast></p-toast>
    </div>
  
    <p-card class="card-wallet col-12">
      <h3 class="main-title mt-0">&nbsp; Montos Generales</h3>
      <div class="flex gap-3 p-0 col-12">
        <div class="p-card-container wallet-section col-3">
          <p class="p-card-text">Valor cartera: 
            <strong *ngIf="!loading; else skeletonAmount">{{ wallet.wallet | currency }}</strong>
          </p>
        </div>
        <div class="p-card-container wallet-section col-3">
          <p class="p-card-text">Cartera sin accesorios: 
            <strong *ngIf="!loading; else skeletonAmount">{{ wallet.walletWithoutAccessories | currency }}</strong>
          </p>
        </div>
        <div class="p-card-container wallet-section col-3">
          <p class="p-card-text">Arrendamientos activos: 
            <strong *ngIf="!loading; else skeletonLeaseCount">{{ wallet.leaseCount }}</strong>
          </p>
        </div>
      </div>
    </p-card>
  
    <div class="row">
      <div class="col-12">
        <app-main-table 
          [columns]="columns"
          [pluralEntityName]="'créditos'"
          [apiService]="apiAdminWalletService"
        ></app-main-table>
      </div>
    </div>
  
    <!-- Skeletons -->
    <ng-template #skeletonAmount>
      <p-skeleton width="8rem"></p-skeleton>
    </ng-template>
  
    <ng-template #skeletonLeaseCount>
      <p-skeleton width="4rem"></p-skeleton>
    </ng-template>
  
  </p-card>
  